import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { LogoMark } from '@/components/generals/logo'

interface DeviceFallbackProps {
    className?: string
}

/**
 * Static rendering of the device for browsers without WebGL.
 * Layered gradients and shadows approximate the matte sage body,
 * the champagne-gold seam and the raised Veyra mark.
 */
export const DeviceFallback: FC<DeviceFallbackProps> = ({ className }): ReactNode => {
    return (
        <div aria-hidden='true' className={cn('relative aspect-[1.536] w-full [perspective:1400px]', className)}>
            <div className='absolute -bottom-[16%] left-[12%] right-[12%] h-[16%] rounded-[50%] bg-burgundy/30 blur-2xl' />

            <div
                className='absolute inset-0 rounded-[14%/22%] [transform:rotateX(14deg)_rotateY(-20deg)_rotateZ(3deg)]'
                style={{
                    background: 'linear-gradient(150deg, #b9c1b2 0%, #9da696 44%, #7e8878 100%)',
                    boxShadow: 'inset 0 2px 1px rgb(255 255 255 / 0.45), inset 0 -8px 18px rgb(0 0 0 / 0.18), 0 0 0 2px #d6be90, 0 46px 70px -34px rgb(57 26 24 / 0.55)'
                }}
            >
                <div className='absolute left-1/2 top-[49%] flex size-[30%] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[#d6be90]/80'>
                    <LogoMark className='size-[64%] text-[#dcc396] drop-shadow-[0_1px_0_rgb(255_255_255/0.4)]' />
                </div>

                <span className='absolute bottom-[14%] left-1/2 size-[2%] -translate-x-1/2 rounded-full bg-[#f1d6a2] shadow-[0_0_8px_#f1d6a2]' />
            </div>
        </div>
    )
}
